import productModel from './productModel';


const clickModel = function googleAnalyticsProductClickModel(product, list, options = {}) {
  return {
    event: 'select_item',
    ecommerce: {
      item_list_name: list,
      items: [
        { ...productModel(product, { list }) },
      ],
    },
    eventCallback: () => {
      if (options.stopRedirect) {
        return null;
      }

      if (options.external) {
        return window.open(product.productUrl);
      }

      return window.location.assign(product.productUrl);
    },
  };
};

export default clickModel;
